import React from 'react';
import { Reveal } from '../Reveal';
import { Countdown } from '../Countdown';
import { CTAButton } from '../CTAButton';
import { plans } from '../../data/programa';
export function FinalCTA() {
  const standard = plans[0];
  return <section className="relative overflow-hidden border-b border-line bg-ink py-[60px] lg:py-[100px]" data-id="element-117" data-mp="3msyy9oz54js6">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(60%_70%_at_50%_50%,rgba(255,159,28,0.14)_0%,rgba(10,15,30,0)_75%)]" aria-hidden="true" data-id="element-118" data-mp="3rrad6e4alkh9" />
      <div className="relative mx-auto max-w-3xl px-6 text-center lg:px-10" data-id="element-119" data-mp="3huxj3f4u54lz">
        <Reveal data-id="element-120" data-mp="33v5xas82ujxf">
          <h2 className="text-3xl font-bold leading-[1.1] tracking-tight text-gold sm:text-[44px]" data-id="element-121" data-mp="33vpgsdddlgdk">
            El próximo lunes puede ser diferente.
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-[17px] leading-[1.7] text-cool" data-id="element-122" data-mp="38vtxo4i74d4b">
            420+ páginas de protocolos accionables, 6 bonos incluidos y acceso en
            menos de 5 minutos.
          </p>
        </Reveal>

        <Reveal delay={0.06} className="mt-12" data-id="element-123" data-mp="q83n6zrce7hs">
          <Countdown label="El precio cierra en" data-id="element-124" data-mp="q6sp9gkkvtyl" />
        </Reveal>

        <Reveal delay={0.1} className="mx-auto mt-12 max-w-md" data-id="element-125" data-mp="l8hf14qdfhfu">
          <CTAButton pulse data-id="element-126" data-mp="z0p7ikamgm8q">Quiero acceder ya mismo</CTAButton>
          
        </Reveal>
      </div>
    </section>;
}